import Box3Iterator from './box3Iterator';

const defaultBox = new THREE.Box3();
const defaultMatrix = new THREE.Matrix4();
const inverse = new THREE.Matrix4();

let descBox;

class TransformedBox3 {
    constructor(box = defaultBox, matrix = defaultMatrix) {
        this.box = box.clone();
        this.matrix = matrix.clone();
    }

    copy(box) {
        this.box.copy(box.box);
        this.matrix.copy(box.matrix);
        return this;
    }

    clone() {
        return new TransformedBox3(this.box, this.matrix);
    }

    makeEmpty() {
        this.box.makeEmpty();
        return this;
    }

    isEmpty() {
        return this.box.isEmpty();
    }

    corners(target = new THREE.Vector3()) {
        const box3It = new Box3Iterator(this.box, target);
        return new Iterator(box3It, this.matrix);
    }

    applyMatrix4(matrix) {
        this.matrix.premultiply(matrix);
        return this;
    }

    union(box) {
        inverse.getInverse(this.matrix);

        for (const corner of box.corners()) {
            corner.applyMatrix4(inverse);
            this.box.expandByPoint(corner);
        }

        return this;
    }

    _setFromObjectSingle(object) {
        this.matrix.copy(object.matrixWorld);

        if (object.geometry) {
            if (!object.geometry.boundingBox) {
                object.geometry.computeBoundingBox();
            }

            this.box.copy(object.geometry.boundingBox);
        } else {
            this.makeEmpty();
        }
    }

    _setFromObjectTree(object) {
        this._setFromObjectSingle(object);

        for (const child of object.children) {
            child.traverse((obj) => {
                descBox._setFromObjectSingle(obj);

                if (!descBox.isEmpty()) {
                    this.union(descBox);
                }
            });
        }
    }

    setFromObject(object) {
        object.updateMatrixWorld(true);
        this._setFromObjectTree(object);
        return this;
    }
}

class Iterator {
    constructor(box3Iterator, matrix) {
        this._box3Iterator = box3Iterator;
        this._matrix = matrix;
    }

    reset() {
        this._box3Iterator.reset();
    }

    next() {
        const itVal = this._box3Iterator.next();

        if (!itVal.done) {
            itVal.value.applyMatrix4(this._matrix);
        }

        return itVal;
    }

    [Symbol.iterator]() {
        return this;
    }
}

descBox = new TransformedBox3();

TransformedBox3.Iterator = Iterator;

export { TransformedBox3, Iterator };
export default TransformedBox3;
